import { events } from '@estee/elc-service-bus';
import { Event } from '~entities/Event';
import { EventRepository } from '~repositories/EventRepository';
import serviceNames from '~setup/AnalyticsService';
import { diContainer } from '~setup/diContainer';

export class AppointmentAccountButtonClickedUseCase {
    private accountButtonLabel: string;
    private eventRepository: EventRepository;

    constructor(accountButtonLabel: string) {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
        this.accountButtonLabel = accountButtonLabel;
    }

    public async execute() {
        const appointmentAccountButtonClickedPayload = {
            event_name: 'appointment booking',
            event_category: 'appointment booking',
            event_action: 'completion page interaction',
            event_label: this.accountButtonLabel
        };

        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: events.APPOINTMENT_ACCOUNT_BUTTON_CLICKED,
            type: 'link',
            payload: appointmentAccountButtonClickedPayload
        });

        this.eventRepository.addEventToQueue(newEvent);
    }
}
